import React, { useEffect, useState } from 'react'
import SvgLogo from '../../SvgLogo/SvgLogo'
import './index.css'

interface IProps {
  loading: boolean
  defaultDescription?: string
  title?: string
  description?: string
  loaderColor?: string
  titleSize?: number
  titleColor?: string
}

const Loading = (props: IProps) => {
  const [interLoading, setInterLoading] = useState<Boolean>(false)
  useEffect(() => {
    if (props.loading) {
      setTimeout(function () {
        if (props.loading) setInterLoading(true)
        else setInterLoading(false)
      }, 1000)
    } else setInterLoading(false)
  }, [props.loading])

  return (
    <>
      {interLoading && props.loading ? (
        <div className="splash_screen_wrapper">
          <div className={'splash_screen'}>
            <div
              style={{
                fontSize: props.titleSize && `${props.titleSize}rem`,
                color: props.titleColor && props.titleColor,
              }}
              className="spalesh_title splash_title_color splash_title_size"
            >
              {/* {title} */}
            </div>
            <div className="splash_screen_icon_logo">
              <SvgLogo />
            </div>
            <div className="splash_screen_loading">
              <div
                style={{ backgroundColor: props.loaderColor && props.loaderColor }}
                className="splash_screen_loading_progress splash_screen_loading_progress_bgColor"
              ></div>
            </div>
            <div className="splash_screen_description">
              {props.description ? props.description : props.defaultDescription}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default Loading
